import React from 'react';
import PropTypes from 'prop-types';

import { getItemsCount, getSaleTypes, getShipped, getPending, getDropship } from 'pages/MyAccount/utils/orders';
import CollapsibleBar from '../CollapsibleBar';
import OrderSummary from '../OrderSummary';
import MobileProductList from '../MobileProductList';
import styles from './styles.module.scss';

const OrderDetails = ({ order, onClickBack, trackShipment }) => {
  const { billingDate, shipments, orderTotalInCents, shippingAddress } = order;
  const saleType = getSaleTypes(shipments);
  const shipped = getShipped(shipments);
  const pending = getPending(shipments);
  const dropship = getDropship(shipments);
  const handleTrackShipment = (trackingNumber) => trackShipment(order, trackingNumber);

  return (
    <div className={styles['order-details']}>
      <button type="button" className={styles['back-button']} onClick={onClickBack}>
        <i className="far fa-chevron-left" />
        Back to Orders
      </button>
      <h1>{saleType}</h1>
      <div className={styles['details-container']}>
        <CollapsibleBar title="Order Details" headerClickable>
          <OrderSummary
            billingDate={billingDate}
            items={getItemsCount(shipments)}
            orderTotal={orderTotalInCents/100}
            shippingAddress={shippingAddress}
          />
        </CollapsibleBar>
      </div>
      <div className={styles.shipments}>
        <h2 className={styles.title}>Shipments</h2>
        <MobileProductList
          shipped={shipped}
          pending={pending}
          dropship={dropship}
          trackShipment={handleTrackShipment}
        />
      </div>
    </div>
  );
}

OrderDetails.propTypes = {
  order: PropTypes.shape({}).isRequired,
  onClickBack: PropTypes.func.isRequired,
  trackShipment: PropTypes.func.isRequired,
};

export default OrderDetails;
